// Create Campaign page
const CREATE_CAMPAIGN = 'CREATE_CAMPAIGN';
const DELETE_CAMPAIGN = 'DELETE_CAMPAIGN';
const START_CAMPAIGN = 'START_CAMPAIGN';

// Datasets page
const CREATE_DATASET = 'CREATE_DATASET';
const DELETE_DATASET = 'DELETE_DATASET';
const SET_COLUMN_FILTERS = 'SET_COLUMN_FILTERS';

export { CREATE_CAMPAIGN, DELETE_CAMPAIGN, START_CAMPAIGN };
export { CREATE_DATASET, DELETE_DATASET, SET_COLUMN_FILTERS };
